<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">{{formatType(type).title}}</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">{{formatType(type).value}}</span>
			<div class="inner-btn" @click="changeType">
				{{type=='list'?'添加卡密':'返 回'}}
			</div>
		</div>
		<ListCard ref="list" v-if="type==='list'" @toEdit="toEdit"></ListCard>
		<AddCard v-if="type==='add'" @back="back"></AddCard>
		<EditCard v-if="type==='edit'" @back="back" :card="card"></EditCard>
	</div>
</template>

<script>
	import ListCard from '../../components/card/ListCard.vue'
	import AddCard from '../../components/card/AddCard.vue'
	import EditCard from '../../components/card/EditCard.vue'
	let types = {
		list:{
			title:'卡密列表',
			value:'card list'
		},
		add:{
			title:'添加卡密',
			value:'add card'
		},
		edit:{
			title:'修改卡密',
			value:'edit card'
		}
	}
	export default {
		components:{
			ListCard,
			AddCard,
			EditCard
		},
		data() {
			return {
				type:'list',
				card:null
			}
		},
		methods:{
			
			formatType(value){
				return types[value]
			},
			changeType(){
				if(this.type==='add'||this.type==='edit'){
					this.type ='list'
				}else{
					this.type = 'add'
				}
				console.log(this.type)
			},
			back(){
				this.type = 'list'
				setTimeout(()=>{
					this.$refs.list.search()
				},500)
				
			},
			toEdit(card){
				this.card = card
				this.type = 'edit'
			}
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}
	.page .container-fluid .inner-btn{
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor:pointer;
	}

</style>